const api = {
	listMallStoreUsers: '/storeUser/listMallStoreUsers',      // 商城账号列表
	addStoreUser: '/storeUser/addStoreUser',        //添加账员
	addMallStoreUser: '/storeUser/addMallStoreUser',        // 商城添加账员
	deleteMallStoreUser: '/storeUser/deleteMallStoreUser',  // 商城删除账号
	editMallStoreUser: '/storeUser/editMallStoreUser ',      // 商城编辑账号
	getMallUserDetail: '/storeUser/getMallStoreUserDetail',   // 商城查询账号详情
	listMallUserGroups: '/userGroup/listMallUserGroups', // 商城岗位列表
	changeMallStoreUserStatus: '/storeUser/changeMallStoreUserStatus',  // 商城修改账号状态
	changeMallSuperAdministrator: '/storeUser/changeMallSuperAdministrator', // 商城更换管理员
	sendVerificationCode: '/message/sendVerificationCode', // 发送验证码
	sendMallVerificationCode: '/storeUser/sendMallVerificationCode', // 商城店铺发送验证码
	checkVerificationCode: '/message/checkVerificationCode' // 校验验证码
};

const routes = {
	'/mall-staff': '账号管理',
};

export { api, routes };
